module.exports = __webpack_public_path__ + "img/leaf_5.31638fed.png";